import { IconName } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../../assets/hot-fixes.scss";
import { GetScheduleDetails, ScheduleResource } from "@mikros/library";
import { format } from "date-fns";
import { Alert, Confirm, MenuOptions } from "@mikros/shared-ui";
import { FormattedMessage, useIntl } from "react-intl";
import React, { useEffect, useState } from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import ApiServices from "../../service/apiService";
import { Popover, Whisper } from "rsuite";
import Account from "../../utils/apiConfig";
import ErrorHandler from "../../utils/errorConfig";
import { useNavigate } from "react-router-dom";

export interface ScheduleCardProps {
  scheduleCardResourse: ScheduleResource;
  onReload: () => void;
  homeScreenState: Function;
  fetchScreenState: Function;
  currentScheduleFunction: Function;
  getScheduleDetails: (scheduleId: string) => Promise<GetScheduleDetails>;
  click: () => void;
}

export function ScheduleCard(props: ScheduleCardProps) {
  const intl = useIntl();

  const accountInstance = Account.getInstance();
  const errorInstance = ErrorHandler.getErrorInstance();
  const navigate = useNavigate();
  const [visible, setVisible] = React.useState<boolean>(false);
  const [scheduleRename, setScheduleRename] = useState(
    props.scheduleCardResourse.scheduleName
  );
  const [delDialog, setdelDialog] = React.useState<boolean>(false);
  const [pause, setPause] = React.useState<boolean>(false);
  const [play, setPlay] = React.useState<boolean>(false);
  const [delError, setDelError] = React.useState<boolean>(false);
  const [stopDialog, setStopDialog] = React.useState<boolean>(false);
  const [statusChange, setStatusChange] = React.useState<boolean>(false);
  const [isHovered, setIsHovered] = useState(false);
  const [courseNameHovered, setCourseNameHovered] = useState(false);
  const [cohortNameHovered, setCohortNameHovered] = useState(false);

  //error
  const [errorFlag, setErrorFlag] = useState<boolean>(false);
  console.log("error flag value", errorFlag);

  const maxLength = 50;
  const maxCohortLength = 40;

  const speaker = (
    <Popover
      title={intl.formatMessage({
        id: "schedule.scheduleCard.fullScheduleName",
      })}
    >
      <p>{props.scheduleCardResourse.scheduleName}</p>
    </Popover>
  );
  const courseSpeaker = (
    <Popover
      title={intl.formatMessage({
        id: "schedule.scheduleCard.fullCourseName",
      })}
    >
      <p>{props.scheduleCardResourse.courseName}</p>
    </Popover>
  );
  const cohortSpeaker = (
    <Popover
      title={intl.formatMessage({
        id: "schedule.scheduleCard.fullCohortName",
      })}
    >
      <p>{props.scheduleCardResourse.cohortName}</p>
    </Popover>
  );

  const scheduleCard = props.scheduleCardResourse;
  const toggleRenameDialog = () => {
    setVisible(!visible);
  };

  const handleTextBoxChange = (text: string) => {
    setScheduleRename(text);
  };

  const toggledelDialog = () => {
    setdelDialog(!delDialog);
  };
  const togglestopDialog = () => {
    setStopDialog(!stopDialog);
  };
  const togglestatusChangeDialog = () => {
    setStatusChange(!statusChange);
  };

  const icon =
    scheduleCard.status === "PAUSED" ? (
      <FontAwesomeIcon
        icon={["far", "fa-play" as IconName]}
        className="fa-fa w-4 h-4 text-mk-primary-bright"
        color="gray"
      />
    ) : (
      <FontAwesomeIcon
        icon={["far", "fa-pause" as IconName]}
        className="fa-fa w-4 h-4 text-mk-primary-bright"
        color="gray"
      />
    );

  const options = [
    {
      icon: (
        <FontAwesomeIcon
          icon={["far", "pencil" as IconName]}
          className="fa-fa w-4 h-4 text-mk-primary-bright"
          color="gray"
        />
      ),
      label: intl.formatMessage({ id: "courses.courseCard.renameLabel" }),
      value: "rename",
    },
    {
      icon: (
        <FontAwesomeIcon
          icon={["far", "trash-can" as IconName]}
          className="fa-fa w-4 h-4 text-mk-primary-bright"
          color="gray"
        />
      ),
      label: intl.formatMessage({ id: "courses.courseStattus.DeleteLabel" }),
      value: "delete",
    },
    {
      icon,
      label:
        scheduleCard.status === "PAUSED"
          ? intl.formatMessage({ id: "resumeLabel" })
          : intl.formatMessage({ id: "courses.courseStatus.PauseLabel" }),
      value: scheduleCard.status === "PAUSED" ? "resume" : "pause",
    },
    {
      icon: (
        <FontAwesomeIcon
          icon={["far", "square-xmark" as IconName]}
          className="fa-fa w-4 h-4 text-mk-primary-bright"
          color="gray"
        />
      ),
      label:
        // "Stop"
        intl.formatMessage({ id: "stopLabel" }),
      value: "stop",
    },
  ];

  console.log("schedule card status", scheduleCard.status);
  const togglePauseStatus = () => {
    setPause(!pause);
  };
  const togglePlayStatus = () => {
    setPlay(!play);
  };
  const toggleScheduleDelError = () => {
    setDelError(!delError);
  };

  const checkAmPm = (): string => {
    const dt = new Date(props.scheduleCardResourse.startDate);
    if (dt.getHours() > 12) {
      return " PM";
    } else if (dt.getHours() === 12) {
      return " NOON";
    }
    return " AM";
  };

  const getCorrectDays = () => {
    let date = "on";
    if (
      props.scheduleCardResourse.scheduleInfo.displayCode === "REWE" &&
      props.scheduleCardResourse.scheduleInfo.onCode
    ) {
      let startWeekNumber = props.scheduleCardResourse.scheduleInfo.onCode;

      for (let i = 0; i < startWeekNumber.length; i++) {
        if (startWeekNumber.at(i) === "1") {
          date =
            date +
            " " +
            intl.formatMessage({
              id: `schedule.landingpage.frequency.REWE.${i + 1}`,
            });
        }
      }
    }

    if (
      props.scheduleCardResourse.scheduleInfo.displayCode === "REMO" &&
      props.scheduleCardResourse.scheduleInfo.onCode
    ) {
      date = intl.formatMessage({
        id: `schedule.landingpage.frequency.REMO.${props.scheduleCardResourse.scheduleInfo.onCode}`,
      });
    }

    return date;
  };

  const handleViewClick = () => {
    props.homeScreenState(false);
    props.fetchScreenState(true);
    const userScheduleDetails = props.getScheduleDetails(
      props.scheduleCardResourse.scheduleId
    );
    console.log("schedule details", userScheduleDetails);
  };

  async function menuSelected(data: any) {
    if (data === "rename") {
      toggleRenameDialog();
    }
    if (data === "delete") {
      toggledelDialog();
    }
    if (data === "pause") {
      togglePauseStatus();
    }
    if (data === "resume") {
      togglePlayStatus();
    }
    if (data === "stop") {
      togglestopDialog();
    }

    if (
      (scheduleCard.status === "STOPPED" ||
        scheduleCard.status === "COMPLETED" ||
        scheduleCard.status === "CANCELLED") &&
      data !== "rename"
    ) {
      togglestatusChangeDialog();
      // setErrorFlag(true)
      if (data === "pause") {
        setPause(false);
      }
      if (data === "resume") {
        setPlay(false);
      }
      if (data === "delete") {
        setdelDialog(false);
      }
      if (data === "stop") {
        setStopDialog(false);
      }
    }
    if (
      data === "delete" &&
      (scheduleCard.status === "PAUSED" || scheduleCard.status === "ACTIVE") &&
      (data !== "rename" || data !== "resume" || data !== "pause")
    ) {
      toggleScheduleDelError();
      if (data === "pause") {
        setPause(false);
      }
      if (data === "resume") {
        setPlay(false);
      }
      if (data === "delete") {
        setdelDialog(false);
      }
    }
  }

  useEffect(() => {
    async function initializeAndUseAccount() {
      await accountInstance.fetchAccountId();
      console.log(
        "account id instance in tenant side",
        accountInstance.accntId
      );
    }
    initializeAndUseAccount();
  }, []);

  return (
    <div>
      {visible && (
        <Dialog className="renameDialog">
          <Confirm
            successText={intl.formatMessage({ id: "user.cohortList.save" })}
            failureText={intl.formatMessage({
              id: "users.cohortDisplay.cancel",
            })}
            textBoxRequired={true}
            intialTextValue={props.scheduleCardResourse.scheduleName}
            onSuccess={() => {
              let body = { ...props.scheduleCardResourse };

              let bufferObj = Buffer.from(scheduleRename, "utf8");

              console.log("print bufferObj", bufferObj);
              let base64string = bufferObj.toString("base64");
              console.log("print base64string", base64string);

              body.scheduleName = scheduleRename;

              console.log("schedule name rename", body.scheduleName);

              let api = ApiServices.getInstance();

              if (accountInstance.accntId) {
                api
                  .makeRequest(
                    `${accountInstance.accntId}/schedule/${props.scheduleCardResourse.scheduleId}?action=NAME&value=${base64string}`,
                    "PUT",
                    body
                  )
                  .then(async (res) => {
                    if (res && res.errorMessage) {
                      setErrorFlag(true);
                      await errorInstance.updateErrorCode(res.errorMessage);
                      return;
                    }
                    props.onReload();
                    console.log("form response", res);
                  });
              }

              toggleRenameDialog();
            }}
            onFailure={toggleRenameDialog}
            textBoxValue={handleTextBoxChange}
          />
        </Dialog>
      )}

      {delDialog && (
        <Dialog className="warningDialogue">
          <Confirm
            description={intl.formatMessage({
              id: "schedule.deleteSchdeuleDialog",
            })}
            successText={intl.formatMessage({
              id: "users.cohortList.deletionSuccess",
            })}
            failureText={intl.formatMessage({
              id: "users.cohortList.deletionFailure",
            })}
            icon={"warningShape.png"}
            iconMsg={intl.formatMessage({ id: "iconMsgWarning" })}
            backgroundColor={"mk-orange"}
            onSuccess={() => {
              let body = { ...props.scheduleCardResourse };
              let api = ApiServices.getInstance();

              if (accountInstance.accntId) {
                api
                  .makeRequest(
                    `${accountInstance.accntId}/schedule/${props.scheduleCardResourse.scheduleId}?action=STATUS&value=DELETE`,
                    "PUT",
                    body
                  )
                  .then(async (res) => {
                    console.log("inside del response of schedule card");
                    if (res && res.errorMessage) {
                      setErrorFlag(true);
                      await errorInstance.updateErrorCode(res.errorMessage);
                      return;
                    }

                    console.log("del response", res);
                    props.onReload();
                  });
              }
              toggledelDialog();
            }}
            onFailure={toggledelDialog}
          />
        </Dialog>
      )}

      {pause && (
        <Dialog className="warningDialogue">
          <Confirm
            description={intl.formatMessage({ id: "schedule.pauseDialog" })}
            successText={intl.formatMessage({
              id: "users.cohortList.deletionSuccess",
            })}
            failureText={intl.formatMessage({
              id: "users.cohortList.deletionFailure",
            })}
            icon={"warningShape.png"}
            iconMsg={intl.formatMessage({ id: "iconMsgWarning" })}
            backgroundColor={"mk-orange"}
            onSuccess={() => {
              togglePauseStatus();
              console.log(
                "print pause,schecule.card.status",
                pause,
                scheduleCard.status
              );
              let body = { ...props.scheduleCardResourse };
              body.status = "ACTIVE";
              let api = ApiServices.getInstance();
              if (accountInstance.accntId) {
                api
                  .makeRequest(
                    `${accountInstance.accntId}/schedule/${props.scheduleCardResourse.scheduleId}?action=STATUS&value=PAUSED`,
                    "PUT",
                    body
                  )
                  .then(async (res) => {
                    if (res && res.errorMessage) {
                      setErrorFlag(true);
                      await errorInstance.updateErrorCode(res.errorMessage);
                      return;
                    }

                    props.onReload();
                  });
              }
            }}
            onFailure={togglePauseStatus}
          />
        </Dialog>
      )}
      {play && (
        <Dialog className="warningDialogue">
          <Confirm
            description={intl.formatMessage({ id: "schedule.playDialog" })}
            successText={intl.formatMessage({
              id: "users.cohortList.deletionSuccess",
            })}
            failureText={intl.formatMessage({
              id: "users.cohortList.deletionFailure",
            })}
            icon={"warningShape.png"}
            iconMsg={intl.formatMessage({ id: "iconMsgWarning" })}
            backgroundColor={"mk-orange"}
            onSuccess={() => {
              togglePlayStatus();
              console.log(
                "print play,schecule.card.status",
                play,
                scheduleCard.status
              );
              let body = { ...props.scheduleCardResourse };
              body.status = "PAUSED";
              let api = ApiServices.getInstance();
              if (accountInstance.accntId) {
                api
                  .makeRequest(
                    `${accountInstance.accntId}/schedule/${props.scheduleCardResourse.scheduleId}?action=STATUS&value=ACTIVE`,
                    "PUT",
                    body
                  )
                  .then(async (res) => {
                    if (res && res.errorMessage) {
                      setErrorFlag(true);
                      await errorInstance.updateErrorCode(res.errorMessage);
                      return;
                    }
                    console.log("status response", res);

                    props.onReload();
                  });
              }
            }}
            onFailure={togglePlayStatus}
          />
        </Dialog>
      )}
      {stopDialog && (
        <Dialog className="warningDialogue">
          <Confirm
            description={intl.formatMessage({ id: "schedule.stopDialog" })}
            successText={intl.formatMessage({
              id: "users.cohortList.deletionSuccess",
            })}
            failureText={intl.formatMessage({
              id: "users.cohortList.deletionFailure",
            })}
            icon={"warningShape.png"}
            iconMsg={intl.formatMessage({ id: "iconMsgWarning" })}
            backgroundColor={"mk-orange"}
            onSuccess={() => {
              togglestopDialog();
              let body = { ...props.scheduleCardResourse };
              body.status = "STOPPED";
              let api = ApiServices.getInstance();
              if (accountInstance.accntId) {
                api
                  .makeRequest(
                    `${accountInstance.accntId}/schedule/${props.scheduleCardResourse.scheduleId}?action=STATUS&value=STOPPED`,
                    "PUT",
                    body
                  )
                  .then(async (res) => {
                    if (res && res.errorMessage) {
                      console.log(
                        "entered the error message for stop",
                        res.errorMessage
                      );
                      setErrorFlag(true);
                      await errorInstance.updateErrorCode(res.errorMessage);
                      return;
                    }

                    console.log("stop response", res);

                    props.onReload();
                  });
              }
            }}
            onFailure={togglestopDialog}
          />
        </Dialog>
      )}
      {statusChange && (
        <Dialog className="errorDialogue">
          <Alert
            description={`${intl.formatMessage({
              id: "schedule.statusChange",
            })}`}
            buttonText={`${intl.formatMessage({ id: "users.buttonText.Ok" })}`}
            icon={"errorShape.png"}
            iconMsg={intl.formatMessage({ id: "iconMsgError" })}
            backgroundColor={"mk-red"}
            onClick={() => {
              console.log("print statusChange", statusChange);
              togglestatusChangeDialog();
            }}
          />
        </Dialog>
      )}
      {delError && (
        <Dialog className="errorDialogue">
          <Alert
            description={`${intl.formatMessage({
              id: "schedule.deletionError",
            })}`}
            buttonText={`${intl.formatMessage({ id: "users.buttonText.Ok" })}`}
            icon={"errorShape.png"}
            iconMsg={intl.formatMessage({ id: "iconMsgError" })}
            backgroundColor={"mk-red"}
            onClick={() => {
              console.log("print statusChange", statusChange);

              toggleScheduleDelError();
            }}
          />
        </Dialog>
      )}

      {errorFlag && (
        <Dialog className="errorDialogue">
          <Alert
            description={intl.formatMessage({
              id: errorInstance.errorCode,
            })}
            buttonText={`${intl.formatMessage({
              id: "users.buttonText.Ok",
            })}`}
            icon={"errorShape.png"}
            iconMsg={intl.formatMessage({
              id: "iconMsgError",
            })}
            backgroundColor={"mk-red"}
            onClick={() => {
              setErrorFlag(false);
              if (errorInstance.permDenied === true) {
                navigate("/home");
              } else {
                navigate("/scheduler");
              }
            }}
          />
        </Dialog>
      )}
      <div className="h-80 flex flex-col text-black justify-between shadow-xl rounded-2xl">
        <div className="inner-shadow flex flex-col justify-around rounded-t-2xl ps-2 h-full">
          <h1
            className="font-bold  text-sm ps-2 pe-1 pt-3"
            onMouseEnter={() =>
              props.scheduleCardResourse.scheduleName.length > maxLength &&
              setIsHovered(true)
            }
            onMouseLeave={() => setIsHovered(false)}
          >
            {isHovered &&
            props.scheduleCardResourse.scheduleName.length > maxLength ? (
              <Whisper
                placement="top"
                controlId="control-id-hover"
                speaker={speaker}
                trigger="hover"
              >
                <div>
                  {props.scheduleCardResourse.scheduleName.slice(0, maxLength) +
                    "..."}
                </div>
              </Whisper>
            ) : props.scheduleCardResourse.scheduleName.length > maxLength ? (
              props.scheduleCardResourse.scheduleName.slice(0, maxLength) +
              "..."
            ) : (
              props.scheduleCardResourse.scheduleName
            )}
          </h1>

          <div className="w-full space-y-1.5 pr-2">
            <div className="w-full flex justify-start items-center gap-x-3">
              <div className="justify-center items-center">
                <FontAwesomeIcon
                  icon={["far", "fa-book-open" as IconName]}
                  className="fa-fw w-4"
                />
              </div>
              <div>
                <h1
                  className="text-sm"
                  onMouseEnter={() =>
                    props.scheduleCardResourse.courseName.length > maxLength &&
                    setCourseNameHovered(true)
                  }
                  onMouseLeave={() => setCourseNameHovered(false)}
                >
                  {courseNameHovered &&
                  props.scheduleCardResourse.courseName.length > maxLength ? (
                    <Whisper
                      placement="top"
                      controlId="control-id-hover"
                      speaker={courseSpeaker}
                      trigger="hover"
                    >
                      <div>
                        {props.scheduleCardResourse.courseName.slice(
                          0,
                          maxLength
                        ) + "..."}
                      </div>
                    </Whisper>
                  ) : props.scheduleCardResourse.courseName.length >
                    maxLength ? (
                    props.scheduleCardResourse.courseName.slice(0, maxLength) +
                    "..."
                  ) : (
                    props.scheduleCardResourse.courseName
                  )}
                </h1>

                <div className="text-[8px] ps-1 font-bold text-mk-grey">
                  {props.scheduleCardResourse.chapterCnt} {/* Chapters */}
                  <FormattedMessage id="home.chapters" />,{" "}
                  {props.scheduleCardResourse.cardCnt} {/* Cards */}
                  <FormattedMessage id="home.cards" />
                </div>
              </div>
            </div>
            <div className="w-full flex justify-start items-center gap-x-3">
              <div>
                <FontAwesomeIcon
                  icon={["far", "fa-users" as IconName]}
                  className="fa-fw w-4"
                />
              </div>
              <div>
                <h1
                  className="text-sm"
                  onMouseEnter={() =>
                    props.scheduleCardResourse.cohortName.length >
                      maxCohortLength && setCohortNameHovered(true)
                  }
                  onMouseLeave={() => setCohortNameHovered(false)}
                >
                  {cohortNameHovered &&
                  props.scheduleCardResourse.cohortName.length >
                    maxCohortLength ? (
                    <Whisper
                      placement="top"
                      controlId="control-id-hover"
                      speaker={cohortSpeaker}
                      trigger="hover"
                    >
                      <div>
                        {props.scheduleCardResourse.cohortName.slice(
                          0,
                          maxCohortLength
                        ) + "..."}
                      </div>
                    </Whisper>
                  ) : props.scheduleCardResourse.cohortName.length >
                    maxCohortLength ? (
                    props.scheduleCardResourse.cohortName.slice(
                      0,
                      maxCohortLength
                    ) + "..."
                  ) : (
                    props.scheduleCardResourse.cohortName
                  )}
                </h1>

                <div className="text-[8px] ps-1 font-bold text-mk-grey">
                  {props.scheduleCardResourse.cohortuserCnt}{" "}
                  <FormattedMessage id="home.members"></FormattedMessage>
                  {/* Members */}
                </div>
              </div>
            </div>
            <div className="w-full flex justify-start items-center gap-x-3">
              <FontAwesomeIcon
                icon={["far", "fa-calendar-days" as IconName]}
                className="fa-fw w-4"
              />
              <div>
                <h1 className="text-sm">
                  {props.scheduleCardResourse.scheduleInfo.displayCode
                    ? intl.formatMessage({
                        id: `schedule.landingpage.frequency.${props.scheduleCardResourse.scheduleInfo.displayCode}`,
                      })
                    : props.scheduleCardResourse.scheduleInfo.displayText}
                </h1>
                <div className="text-[8px] ps-1 flex space-x-1 font-bold text-mk-grey">
                  {props.scheduleCardResourse.scheduleInfo.onCode
                    ? getCorrectDays()
                    : props.scheduleCardResourse.scheduleInfo.onText
                    ? props.scheduleCardResourse.scheduleInfo.onText
                    : ""}
                </div>
              </div>
            </div>
            <div className="w-full flex justify-start items-center gap-x-3">
              <div className="justify-start items-start pt-0.5">
                <FontAwesomeIcon
                  icon={["far", "fa-calendar-day" as IconName]}
                  className="fa-fw w-4"
                />
              </div>
              <div className="text-sm pr-2">
                {intl.formatMessage({ id: `startedOn` })}{" "}
                {format(
                  new Date(props.scheduleCardResourse.startDate),
                  "dd-MMM-yyyy"
                ) +
                  " at " +
                  format(
                    new Date(props.scheduleCardResourse.startDate),
                    "hh:mm"
                  ) +
                  `${checkAmPm()}`}
              </div>
            </div>
          </div>

          <div className="flex justify-between w-full pb-3">
            <h1
              className={`text-base font-bold ${
                props.scheduleCardResourse.status === "ACTIVE"
                  ? "text-mk-bright-green"
                  : props.scheduleCardResourse.status === "PAUSED"
                  ? "text-mk-pink"
                  : props.scheduleCardResourse.status === "COMPLETED"
                  ? "text-mk-primary"
                  : props.scheduleCardResourse.status === "STOPPED"
                  ? "text-mk-red"
                  : props.scheduleCardResourse.status === "CANCELLED"
                  ? "text-mk-red"
                  : "text-mk-orange"
              }`}
            >
              {props.scheduleCardResourse.status === "ACTIVE"
                ? intl.formatMessage({
                    id: "scheduleDetails.userReportStatus.inProgress",
                  })
                : props.scheduleCardResourse.status === "PAUSED"
                ? intl.formatMessage({
                    id: "scheduleDetails.userReportStatus.paused",
                  })
                : props.scheduleCardResourse.status === "COMPLETED"
                ? intl.formatMessage({
                    id: "scheduleDetails.userReportStatus.completed",
                  })
                : props.scheduleCardResourse.status === "STOPPED"
                ? intl.formatMessage({
                    id: "scheduleDetails.userReportStatus.stopped",
                  })
                : props.scheduleCardResourse.status === "CANCELLED"
                ? intl.formatMessage({
                    id: "scheduleDetails.userReportStatus.cancelled",
                  })
                : intl.formatMessage({
                    id: "scheduleDetails.userReportStatus.scheduled",
                  })}
            </h1>
            <div className="mr-2 gap-2 flex items-center justify-center">
              {props.scheduleCardResourse.channels.map((ele, index) => (
                <div key={index}>
                  <img
                    src={require(`../../assets/images/${ele
                      .toString()
                      .toLowerCase()}.png`)}
                    alt="email"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>

        <div
          className={`inner-shadow flex rounded-b-2xl justify-between items-center h-[15%] px-3 w-full ${
            props.scheduleCardResourse.status === "ACTIVE"
              ? "bg-mk-mild-green"
              : props.scheduleCardResourse.status === "PAUSED"
              ? "bg-mk-pink"
              : props.scheduleCardResourse.status === "COMPLETED"
              ? "bg-mk-primary"
              : props.scheduleCardResourse.status === "STOPPED"
              ? "bg-mk-red"
              : props.scheduleCardResourse.status === "CANCELLED"
              ? "bg-mk-red"
              : "bg-mk-orange"
          }`}
        >
          <h1
            className="text-sm font-bold pointer-cursor"
            onClick={handleViewClick}
          >
            <FormattedMessage id="schedule.createSchedule.viewProgress"></FormattedMessage>
          </h1>
          <MenuOptions
            options={options}
            onSelect={(data: any) => {
              menuSelected(data);
            }}
          >
            {/* <FontAwesomeIcon
              onClick={(event) => {
                event.stopPropagation();
              }}
              icon={["far", "fa-ellipsis" as IconName]}
              className="fa-fw "
              color="black"
            /> */}

            <div
              onClick={(event) => event.stopPropagation()}
              className="flex items-center justify-center rounded-full p-1 hover:bg-mk-light-grey transition"
            >
              <FontAwesomeIcon
                icon={["far", "fa-ellipsis" as IconName]}
                className="fa-fw"
                color="black"
              />
            </div>
          </MenuOptions>
        </div>
      </div>
    </div>
  );
}
